/**
 * [ホーム画面] 共有のフィルターの選択肢
 */
export const shareOptions = [
  'すべて',
  '全体共有',
  '一部共有',
  '共有なし',
] as const;

/**
 * [ホーム画面] 対象画面のフィルターの選択肢
 * 「すべて」は固定で、その他のオプションはお気に入りデータから動的に取得
 */
export const pageNameFilterAllOption = 'すべて' as const;

/**
 * [ホーム画面] 作成者のフィルターの選択肢
 * 「すべて」は固定で、その他のオプションはお気に入りデータから動的に取得
 */
export const creatorFilterAllOption = 'すべて' as const;
